import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["paymentStatus", "unpaidContent", "paidContent"]
    static values = {
        invoiceId: Number,
        interval: { type: Number, default: 5000 }, // 5 секунд по умолчанию
        url: String
    }

    connect() {
        console.log('Invoice status controller connected!')
        console.log('Invoice ID:', this.invoiceIdValue)
        console.log('Interval:', this.intervalValue)
        console.log('URL:', this.urlValue)

        // Проверяем, что invoiceId передан
        if (!this.invoiceIdValue) {
            console.error('Invoice ID is missing!')
            return
        }

        this.startPolling()
        // Сразу делаем первую проверку
        this.checkPaymentStatus()
    }

    disconnect() {
        console.log('Invoice status controller disconnected')
        this.stopPolling()
    }

    startPolling() {
        console.log('Starting polling...')
        this.pollTimer = setInterval(() => {
            this.checkPaymentStatus()
        }, this.intervalValue)
    }

    stopPolling() {
        if (this.pollTimer) {
            console.log('Stopping polling')
            clearInterval(this.pollTimer)
        }
    }

    async checkPaymentStatus() {
        try {
            const response = await fetch(this.urlValue || `/invoices/${this.invoiceIdValue}/status`)

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()

            if (data.status == 'paid') {
                // this.showPaidContent()
                this.stopPolling() // Останавливаем поллинг после оплаты

                if (data.business_event_registration_id) {
                    window.location.href = `/business_event_registrations/${data.business_event_registration_id}/create_payment`
                } else if (data.group_registration_id) {
                    window.location.href = `/group_registrations/${data.group_registration_id}/create_payment`
                }
            }
        } catch (error) {
            console.error('Ошибка при проверке статуса оплаты:', error)
        }
    }

    showPaidContent() {
        if (this.hasUnpaidContentTarget) {
            this.unpaidContentTarget.style.display = 'none'
        }

        if (this.hasPaidContentTarget) {
            this.paidContentTarget.style.display = 'block'
        }

        // Можно добавить анимацию или уведомление
        this.dispatch('payment-completed', {
            detail: { invoiceId: this.invoiceIdValue }
        })
    }
}